import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';
import { AuthService, isLoggedInGuard } from '@pozi/authmodule';
import { LoginComponent } from './login/login.component';
import { ensureCompanySiteContextGuard } from './shared/guards/ensure-company-site-context.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [
      () =>
        inject(AuthService).$user.value === null
          ? true
          : inject(Router).createUrlTree(['.']),
    ],
  },
  {
    path: '',
    canMatch: [isLoggedInGuard],
    canActivateChild: [ensureCompanySiteContextGuard],
    loadChildren: () =>
      import('./main/main.routes').then((main) => main.routes),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
